import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationNotification } from '../../root/models/application-notification.model';

@Pipe({
    name: 'NotificationsInfoPipe',
    standalone: false
})
export class NotificationsInfoPipe implements PipeTransform {
    constructor() {}

    transform(value: ApplicationNotification[]) {
        const now = new Date();
        const dateLevels = [
            { key: 'today', date: now.toISOString().split('T')[0], label: 'TODAY' },
            { key: 'yesterday', date: new Date(now.setDate(now.getDate() - 1)).toISOString().split('T')[0], label: 'YESTERDAY' },
            { key: 'older', date: null, label: 'DAYS_AGO' }
        ];

        let categorizedNotifications = dateLevels.map(dataLabel => ({
            level: dataLabel.label,
            values: []
        }));

        value.forEach((item: ApplicationNotification) => {
            const createDate = new Date(item.CreateDate);
            const createDateString = createDate.toISOString().split('T')[0];

            let timeFormatted = createDate.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });

            let matchedCategory = categorizedNotifications.find(category => category.level === dateLevels.find(dl => dl.date === createDateString)?.label);

            if (!matchedCategory) {
                matchedCategory = categorizedNotifications.find(category => category.level === 'DAYS_AGO');
            }

            if (matchedCategory) {
                item.Time = timeFormatted;
                matchedCategory.values.push(item);
            }
        });

        return categorizedNotifications;
    }

}
